var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('el-radio',{attrs:{"label":"1","border":""},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v("微信")]),_c('el-radio',{attrs:{"label":"2","border":""},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v("支付宝")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }